import { clsx } from "clsx";
import { type ReactNode } from "react";

interface Props {
  htmlFor: HTMLLabelElement["htmlFor"];
  children: ReactNode;
  disabled?: boolean;
}

export default function Label({ children, disabled, htmlFor }: Props) {
  const className = clsx("dark:text-zinc-200", {
    "cursor-default opacity-50": disabled,
  });

  return (
    <label htmlFor={htmlFor} className={className}>
      {children}
    </label>
  );
}
